import { Paddle, initializePaddle } from '@paddle/paddle-js';

let _paddlePromise: Promise<Paddle | undefined> | null = null;

export function getPaddle(): Promise<Paddle | undefined> {
  if (_paddlePromise !== null) return _paddlePromise;

  const token = import.meta.env.VITE_PADDLE_CLIENT_TOKEN as string | undefined;
  if (!token) {
    console.warn('[paddle] VITE_PADDLE_CLIENT_TOKEN is not set — Paddle overlay will not open.');
    return Promise.resolve(undefined);
  }

  const environment =
    (import.meta.env.VITE_PADDLE_ENVIRONMENT as 'production' | 'sandbox') || 'production';

  _paddlePromise = initializePaddle({ environment, token });
  return _paddlePromise;
}
